var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 129,
    viewBox: "0 0 120 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 129H120V105C120 91.7452 109.255 81 96 81H24C10.7452 81 0 91.7452 0 105V129Z",
    fill: "#81C784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8966 73.9661H54.7585V58.7589C54.7585 56.9664 55.4706 55.2473 56.7381 53.9798C58.0056 52.7123 59.7247 52.0002 61.5173 52.0002H68.215C70.3963 51.9698 70.4812 55.3891 68.2686 55.3796C67.8252 55.3795 67.386 55.4669 66.9764 55.6368C66.5668 55.8067 66.1947 56.0558 65.8815 56.3697C65.5683 56.6836 65.3201 57.0562 65.1511 57.4662C64.9821 57.8762 64.8956 58.3155 64.8966 58.7589V73.9661Z",
    fill: "#81C784"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7585 68.3872V73.9663H64.8966V61.5664C62.4308 64.968 58.8385 67.3849 54.7585 68.3872Z",
    fill: "#66BB6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8278 101.001C66.3601 101.001 71.6555 94.1927 71.6555 85.7941C71.6555 77.3954 66.3601 70.5869 59.8278 70.5869C53.2955 70.5869 48 77.3954 48 85.7941C48 94.1927 53.2955 101.001 59.8278 101.001Z",
    fill: "#F09B73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8274 87.4837C59.3792 87.4837 58.9495 87.3057 58.6326 86.9888C58.3157 86.672 58.1377 86.2422 58.1377 85.7941V72.2766C58.1377 71.8285 58.3157 71.3987 58.6326 71.0818C58.9495 70.7649 59.3792 70.5869 59.8274 70.5869C60.2755 70.5869 60.7053 70.7649 61.0222 71.0818C61.339 71.3987 61.5171 71.8285 61.5171 72.2766V85.7941C61.5171 86.2422 61.339 86.672 61.0222 86.9888C60.7053 87.3057 60.2755 87.4837 59.8274 87.4837Z",
    fill: "#DB7F5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.759 90.8628C55.6922 90.8628 56.4487 90.1063 56.4487 89.1731C56.4487 88.2399 55.6922 87.4834 54.759 87.4834C53.8258 87.4834 53.0693 88.2399 53.0693 89.1731C53.0693 90.1063 53.8258 90.8628 54.759 90.8628Z",
    fill: "#F2BBA5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6722 60.4484C62.072 60.4484 63.2067 59.3137 63.2067 57.9139C63.2067 56.5141 62.072 55.3794 60.6722 55.3794C59.2724 55.3794 58.1377 56.5141 58.1377 57.9139C58.1377 59.3137 59.2724 60.4484 60.6722 60.4484Z",
    fill: "#C8E6C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1382 65.5175C59.0714 65.5175 59.8279 64.7611 59.8279 63.8279C59.8279 62.8947 59.0714 62.1382 58.1382 62.1382C57.205 62.1382 56.4485 62.8947 56.4485 63.8279C56.4485 64.7611 57.205 65.5175 58.1382 65.5175Z",
    fill: "#C8E6C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2245 85.7937C53.6242 85.7937 54.759 84.6589 54.759 83.2591C54.759 81.8594 53.6242 80.7246 52.2245 80.7246C50.8247 80.7246 49.6899 81.8594 49.6899 83.2591C49.6899 84.6589 50.8247 85.7937 52.2245 85.7937Z",
    fill: "#F2BBA5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M100.01 0H71.0188C67.7108 0 65.0291 2.68171 65.0291 5.98967C65.0291 7.27358 65.4346 8.46104 66.1236 9.43436C66.5392 10.0216 66.1309 10.8312 65.4114 10.8312H56.1331C52.8855 10.8312 50.1194 13.3568 50.0039 16.6023C49.8827 20.0099 52.6091 22.8102 55.9894 22.8102H84.8233C88.1804 22.8102 91.0325 20.0629 90.9697 16.7064C90.9465 15.4684 90.5461 14.3244 89.8799 13.3806C89.4634 12.7909 89.8672 11.9787 90.5893 11.9787H100.01C103.318 11.9787 106 9.29699 106 5.98903C106 2.68171 103.318 0 100.01 0Z",
    fill: "#DFF6FD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4817 22.3131C58.5972 19.0673 61.3633 16.542 64.611 16.542H71.455C73.0527 16.542 74.2525 15.0037 73.7767 13.4783C73.6015 12.9168 73.507 12.3197 73.507 11.7002C73.507 8.3922 76.1887 5.71049 79.4967 5.71049H105.986C105.839 2.53292 103.224 0 100.011 0H71.0188C67.7108 0 65.0291 2.68171 65.0291 5.98967C65.0291 7.27358 65.4349 8.46104 66.1236 9.43468C66.5392 10.0219 66.1309 10.8315 65.4114 10.8315H56.1331C52.8855 10.8315 50.1194 13.3572 50.0039 16.6026C49.8827 20.0102 52.6091 22.8106 55.9894 22.8106H58.4897C58.4821 22.6459 58.4757 22.4809 58.4817 22.3131Z",
    fill: "#C8EFFE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 112,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 102,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 104,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 118,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage2);
export default __webpack_public_path__ + "static/media/stage2.38e1c861eb4445930a9ad271ac14f283.svg";
export { ForwardRef as ReactComponent };